module.exports = __webpack_public_path__ + "img/06.825bd548.jpg";